<template>
    <b-container 
        class="content" 
        fluid 
    >
        <div class="instructions">
            {{$t('choose-analysis-unit')}}
        </div>
        <b-row align-h="between">
            <b-col cols="4">
                <b-form-select v-model="selectedAnalysisUnit" @change="changeAnalysisUnit">
                    <option :value="'GJ'">GJ</option>
                    <option :value="'MWh'">MWh</option>
                </b-form-select>
            </b-col>
            <b-col v-if="this.gbId(this.$store.state.user.customerId) || this.isbId(this.$store.state.user.customerId)" cols="4">
                <b-row>
                    <b-col>
                        <b-button class="dataExport" @click="$refs.dataLists.show()" size="sm" ><i class="fab fa-dochub"></i></b-button>
                    </b-col>
                </b-row>
                <b-modal ref="dataLists" size="sm" hide-footer hide-header centered>
                    <b-form-select cols="6" v-model="selectedDataList" :options="dataLists" @change="getData($event)"></b-form-select>
                </b-modal>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
export default {
    name: 'Tabs',
    data() {
        return {
            email: null,
            selectedLocale: null,
            selectedAnalysisUnit: null,
            selectedDataList: null,
            dataLists: [
                {
                    value: null,
                    text: this.$t('chooseDataList'),
                    disabled: true
                },
                {
                    value: 'data',
                    text: this.$t('data')
                },
                {
                    value: 'data_type',
                    text: this.$t('dataType')
                },
                {
                    value: 'data_entry',
                    text: this.$t('dataEntry')
                },
                {
                    value: 'data_entry_deleted_year',
                    text: this.$t('deletedDataType')
                },
                {
                    value: 'form',
                    text: this.$t('form')
                },
                {
                    value: 'form_data',
                    text: this.$t('formData')
                },
                {
                    value: 'goal',
                    text: this.$t('goal')
                },
                {
                    value: 'site',
                    text: this.$t('site')
                },
                {
                    value: 'document',
                    text: this.$t('document')
                },
                {
                    value: 'audit_report',
                    text: this.$t('audit')
                },
                {
                    value: 'user',
                    text: this.$t('user')
                },
                {
                    value: 'site_user',
                    text: this.$t('siteUser')
                },
                {
                    value: 'user_group_member',
                    text: this.$t('userPerm')
                },
                {
                    value: 'unit_price',
                    text: this.$t('unitPrice')
                },
                {
                    value: 'emission_factor',
                    text: this.$t('emissionFactor')
                },
                {
                    value: 'log',
                    text: this.$t('log')
                },
                {
                    value: 'integration_user',
                    text: this.$t('integrationUser')
                },
                {
                    value: 'ikon',
                    text: this.$t('ikonLog')
                }
            ]
        };
    },
    methods: {
        changeAnalysisUnit(newVal) {
            this.selectedAnalysisUnit = newVal;
            localStorage.setItem('analysis_unit', newVal);

            this.$Progress.start();
            return this.axios.put(`/resource/${this.$store.state.user.customerId}/analysis_unit_id`, {value: newVal})
            .then(({data}) => {
                this.$store.state.analysis_unit = data;
                this.$Progress.finish()
                });

        },
        getData(val) {
            var hasCustomerId = 1;
            if (
                [
                    'user_group_member',
                    'site_user',
                    'log',
                    'ikon',
                    'integration_user',
                    'unit_price',
                    'form',
                    'form_data',
                    'data_entry_deleted_year'
                ].indexOf(val) != -1
            ) {
                hasCustomerId = 0;
            }
            this.$refs.dataLists.hide();
            window.open(
                `${this.apiURL}/dataListExport?list=${val}&hasCustomerId=${hasCustomerId}&token=${
                    this.downloadToken
                }`
            );
        }
    },
    created() {
        this.downloadToken = this.token.substr(7);
        this.selectedAnalysisUnit = this.$store.state.analysis_unit;
    }
};
</script>

<style scoped lang="scss">
.dataExport {
    float: right;
    width: 10%;
    background-color: rgba(219, 219, 219, 0.1);
    border-color: white;
    &:hover {
        background-color: rgba(219, 219, 219, 1);
    }
}
.instructions {
    text-align: left;
    font-weight: bold;
    padding-bottom: 10px;
}
</style>
<i18n src="../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "chooseDataList": "Bir veri listesi seçin",
            "data": "Kaynak harcamaları",
            "dataType": "Veri tipleri",
            "dataEntry": "Lokasyon veri tipleri",
            "deletedDataType": "Silinmiş veri tipleri",
            "form": "Formlar",
            "formData": "Form detayları",
            "goal": "Hedefler",
            "site": "Lokasyonlar",
            "document": "Dokümanlar",
            "audit": "Denetimler",
            "user": "Kullanıcılar",
            "siteUser": "Lokasyon kullanıcıları",
            "userPerm": "Kullanıcı yetkileri",
            "unitPrice": "Birim fiyatlar",
            "emissionFactor": "Emisyon faktörleri",
            "log": "Kayıtlar",
            "integrationUser": "Entegrasyon kullanıcıları",
            "ikonLog": "Entegrasyon Kayıtları",
            "invite": "Davet Et",
            "choose-analysis-unit": "Enerji Kaynakları için Raporlama Birimi"
        },
        "en": {
            "chooseDataList": "Choose a data list",
            "data": "Data consumptions",
            "dataType": "Data types",
            "deletedDataType": "Deleted data types",
            "dataEntry": "Data types of site",
            "form": "Forms",
            "formData": "Form details",
            "goal": "Goals",
            "site": "Sites",
            "document": "Documents",
            "audit": "Audits",
            "user": "Users",
            "siteUser": "Site users",
            "userPerm": "User permissions",
            "unitPrice": "Unit prices",
            "emissionFactor": "Emission factors",
            "log": "Log",
            "integrationUser": "Integration users",
            "ikonLog": "Integration log",
            "invite": "Invite",
            "choose-analysis-unit": "Reporting Unit for Energy Sources"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Setting/General.vue